/**
 * src/lib/nav/parseDeepLink.js — TICKET-209 (CEO 2026-06-18).
 *
 * Pure boot-time URL → navigation-intent parser. Lets a shared `/deal/<id>` or
 * `/project/<id>` link open that boat directly in-app (the WhatsApp-to-teammate
 * flow). AppShell validates a bare `{ kind: 'tab' }` against VIEW_REGISTRY and
 * routes `deal`/`project` intents through dealNav/projectNav.
 */

export function parseDeepLink(pathname) {
  const segs = String(pathname || '').replace(/^\/+/, '').split('/').filter(Boolean);
  const head = segs[0];
  const id = segs[1];
  if (head === 'deal') return id ? { kind: 'deal', id, tab: 'pipeline' } : null;
  if (head === 'project') return id ? { kind: 'project', id, tab: 'projects' } : null;
  // /quote/<id> opens the full-screen quote builder directly (approver's push tap).
  // The builder is self-contained (fetches its own quote), so no tab switch needed.
  if (head === 'quote') return id ? { kind: 'quote', id } : null;
  if (head) return { kind: 'tab', tab: head };
  return null;
}

/**
 * Apply a parsed deep-link intent via injected side-effects. Kept dep-injected
 * so AppShell stays thin and the routing is unit-testable without rendering the
 * whole shell. `isKnownTab` validates a bare-tab intent against VIEW_REGISTRY.
 */
export function dispatchDeepLink(intent, { setActiveTab, requestDealOpen, requestProjectOpen, requestQuoteOpen, isKnownTab }) {
  if (!intent) return;
  if (intent.kind === 'deal') {
    requestDealOpen(intent.id);
    setActiveTab('pipeline');
  } else if (intent.kind === 'project') {
    requestProjectOpen(intent.id);
    setActiveTab('projects');
  } else if (intent.kind === 'quote') {
    // Full-screen overlay owned by AppShell — no tab change; opens over the
    // current view (requestQuoteOpen absent in older callers = graceful no-op).
    requestQuoteOpen?.(intent.id);
  } else if (intent.kind === 'tab' && isKnownTab(intent.tab)) {
    setActiveTab(intent.tab);
  }
}
